import { render, staticRenderFns } from "./u-file-input-outlined-rounded.vue?vue&type=template&id=4546b938&scoped=true"
import script from "./u-file-input-outlined-rounded.vue?vue&type=script&lang=js"
export * from "./u-file-input-outlined-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546b938",
  null
  
)

export default component.exports